export default __webpack_public_path__ + "static/media/sacrificial_sword.048703ab.png";